// extracted by mini-css-extract-plugin
export default {"root":"UfszJmOk9JPoYJyQCNww","header":"FNXMb568v2ZOEmGBlueq"};